<template>
  <div>
    <SfModal
      :visible="isReviewPopupOpen"
      title="Оставить отзыв"
      class="modal"
      @close="$emit('close')"
    >
      <div >
        <ValidationObserver v-slot="{ handleSubmit }">
        <form class="form" @submit.prevent="handleSubmit(handleSend)">
            <star-rating :increment="0.5" star-size="25" v-model="form.rating" style="margin-bottom: 20px;"></star-rating>
            <ValidationProvider rules="" v-slot="{ errors }">
            <SfTextarea
                v-model="form.comment"
                :valid="!errors[0]"
                :errorMessage="errors[0]"
                :cols="40"
                :rows="10"
                name="comment"
                label="Коммент"
                class="form__element"
                style="width: 100%;"
            />
            </ValidationProvider>
            <SfButton
            type="submit"
            class="sf-button--full-width form__button"
            :disabled="loading"
            >
              <SfLoader :class="{ loader: loading }" :loading="loading">
                  <div>Отправить</div>
              </SfLoader>
            </SfButton>
        </form>
        </ValidationObserver>
      </div>
    </SfModal>
  </div>
</template>
<script>

import apiRequest from '../shared/apiRequest'
import { SfModal, SfButton, SfLoader, SfTextarea } from '@storefront-ui/vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import StarRating from 'vue-star-rating'

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('auth');

extend('required', {
  ...required,
  message: 'Поле обязательное'
});

export default {
  name: 'ReviewPopup',
  components: {
    SfModal,
    SfButton,
    SfLoader,
    SfTextarea,
    ValidationProvider,
    ValidationObserver,
    StarRating
  },

  props: {
    shop_id: Number,
    isReviewPopupOpen: Boolean
  },

  data() {
    return {
      loading: false,
      form: {
        rating: '',
        comment: '',
      },
    }
  },

  methods: {
    handleSend() {
      const form = this.form
      form.user_id = this.user.id;
      form.shop_id = this.shop_id;

      apiRequest.post('/reviews', form)
        .then(() => {
          this.$emit('close');
        });
      
    },
  },
  
  computed: {
    ...mapState({
      user: 'user'
    }),
  }
};
</script>

<style lang="scss" scoped>
.form {
  margin-top: var(--spacer-sm);
  &__element {
    margin: 0 0 var(--spacer-xl) 0;
  }
}
.action,
.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
  font: var(--font-weight--light) var(--font-size--base) / 1.6 var(--font-family--secondary);
  & > * {
    margin: 0 0 0 var(--spacer-xs);
  }
}
.action {
  margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
}
.bottom {
  padding: var(--spacer-xl) 0 0 0;
  border: 1px solid var(--c-light);
  border-width: 1px 0 0 0;
}

</style>

<style lang="scss">
.sf-modal {
  .sf-modal__close {
    display: flex !important;
  }  
}

.modal {
}

</style>

<style lang="scss">
.form {
  &__element {
    textarea {
      width: 100%;
    }
  }
  &__button {
    &:active {
      --button-background: var(--c-primary) !important;
    }
  }
}
</style>
